const crashSound = new Audio("https://brightdigital.co/game/crash.mp3");
const bonusSound = new Audio("https://brightdigital.co/game/bonus.mp3");
const countdownSound = new Audio("https://brightdigital.co/game/countdown.mp3");
const clappingSound = new Audio("https://brightdigital.co/game/clapping.mp3");
const music = new Audio("https://brightdigital.co/game/music.mp3");

music.loop = true;
let isMuted = false;

const canvas = document.getElementById("game");
const ctx = canvas.getContext("2d");
let countdownInProgress = false;
let leaderboard = [];

updateLeaderboard();
function setCanvasSize() {
  canvas.width = window.innerWidth;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  canvas.height = isMobile ? window.innerHeight * 0.7 : window.innerHeight * 0.7;
}

setCanvasSize();

const tourStages = [
  { start: "Paris", end: "Lyon", km: 467, mi: 290.3 },
  { start: "Lyon", end: "Marseille", km: 374, mi: 232.3 },
  { start: "Marseille", end: "Toulouse", km: 424, mi: 263.5 },
  { start: "Toulouse", end: "Bordeaux", km: 268, mi: 166.5 },
  { start: "Bordeaux", end: "Nantes", km: 425, mi: 264.1 },
  { start: "Nantes", end: "Paris", km: 471, mi: 292.7 },
];
let stage = 1;
const finalStage = tourStages.length;
let kmLeft = tourStages[0].km;
let milesLeft = tourStages[0].mi;
const carCollection = window.uciGameAssets.cars;
const carImages = carCollection.map((src) => {
  const img = new Image();
  img.src = src;
  return img;
});

const background = new Image();
background.src = window.uciGameAssets.background;

const riderImg = new Image();
riderImg.src = window.uciGameAssets.rider;

const boostImg = new Image();
boostImg.src = window.uciGameAssets.boost;

let player,
  gravity = 0.9,
  objects = [],
  crashed = false;
let stageProgress = 0;
let showStartMessage = true;
let gameStarted = false;
let stageStartTime = 0,
  showStageText = false,
  stageTextTime = 0;
let lastSpawnTime = 0;

const formContainer = document.getElementById("formContainer");
const countdownEl = document.getElementById("countdown");
const scoresList = document.getElementById("scores");
const keys = {};

// Lock page scroll behind the score/login/create-account popup, whichever content it holds.
new MutationObserver(() => {
  document.body.style.overflow = formContainer.style.display === "block" ? "hidden" : "";
}).observe(formContainer, { attributes: true, attributeFilter: ["style"] });

// "Anonymous" leaderboard entries show a masked email instead, e.g. "ud...@gmail.com".
const maskEmail = (email) => {
  const [user, domain] = (email || "").split("@");
  return domain ? `${user.slice(0, 2)}...@${domain}` : "Anonymous";
};

const defaultPlayer = () => {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const baseWidth = 140;
  const baseHeight = 160;
  const scale = isMobile ? 1 : 1.25;

  const width = baseWidth * scale;
  const height = baseHeight * scale;

  return {
    x: isMobile ? 0 : (canvas.width - width) / 2, // Center on desktop, left side on mobile
    y: canvas.height - height,
    width,
    height,
    vy: 0,
    jumpPower: -15,
    onGround: true,
    energy: 100,
    score: 0,
    scoreSubmitted: false,
    pollingLoginStarted: false,
  };
};

function getOrdinal(n) {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function pollLoginSession(callback) {
  const interval = setInterval(async () => {
    try {
      const res = await fetch("/account", { credentials: "include" });
      const text = await res.text();
      const isLoggedIn = text.includes("Logout") || text.includes("/account/logout");

      if (isLoggedIn) {
        clearInterval(interval);
        callback();
      }
    } catch (err) {
      console.error("Login polling failed:", err);
    }
  }, 1500);
}

async function resetGameState(score = 0) {
  let rank = "";
  let total = "";
  player = defaultPlayer();
  stage = 1;
  crashed = false;
  objects = [];
  const customer = window.shopifyCustomer;
  if (!customer) {
    try {
      const res = await fetch("https://backoffice.brightdigital.co/game/get-rank.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ score }),
      });

      const data = await res.json();
      if (data.success) {
        rank = data.rank;
        total = data.total;
      }
    } catch (err) {
      console.warn("Rank fetch failed:", err);
    }

     // Check & update local high score
    const previousHigh = parseInt(localStorage.getItem("gc_highScore")) || 0;
        let newHigh = false;

    if (score > previousHigh) {
      localStorage.setItem("gc_highScore", score);
      newHigh = true;
    }
     const displayHighScore = Math.max(score, previousHigh);
     const scoreMessage = newHigh
      ? `<p style="color:#f39c12;font-weight:bold;margin-bottom:5px;line-height:1.3;margin-top:20px;font-size:103%;">🔥 Your New High Score: ${score}!</p>`
      : `<p style="margin-bottom:5px; font-size:115%;">Your score: <strong>${score}</strong></p>
         <p style="margin-bottom:5px;color: #eb3223;line-height: 1;font-weight: 700;">Your Highest Score: ${displayHighScore}</p>
         <p style="font-weight: 700;font-size: 80%;margin-bottom: 8px;line-height:1.2;color: #000;margin-top: 20px;">Try again to beat your best and move up the leaderboard!</p>`

    formContainer.innerHTML = `
          <div class="thb-form-container" style="padding-top:10px; padding-bottom:20px; position: relative;">
            <button onclick="closeLoginModal()" style="position: absolute; top: 5px; right: 5px; background: none; border: none; color: red; font-size: 20px; font-weight: bold; cursor: pointer; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border-radius: 50%; background-color: rgba(255, 255, 255, 0.8);">×</button>
            <div class="thb-login-form" id="login-form">
              <img src="//garagecycles.cc/cdn/shop/files/GC-favicon.png?v=1694299441" class="logoimg" alt="Garage Cycles" width="50" height="50" style="margin-bottom:15px;">
              <form method="post" action="/account/login?return_url=/pages/game" accept-charset="UTF-8">
                <input type="hidden" name="form_type" value="customer_login" />
                <input type="hidden" name="utf8" value="✓" />
                <input type="hidden" name="return_to" value="/pages/game" />
                <h4>Log In to store your score</h4>
                <p style="font-size:16px;margin-bottom:10px;">& <b>Save 35% off on your first nutrition order!</b> Plus win additional prizes from us and our partners as you conquer the GC Sprint Challenge leaderboard!</p>
                 ${scoreMessage}
                <p style="margin-bottom:18px; font-weight:bold; font-size:92%;"> ${getOrdinal(rank)} / ${total} Players</p>
                <div class="field">
                  <input type="email" name="customer[email]" class="full " value="" autocomplete="email" autocorrect="off" autocapitalize="off" placeholder="Email address" required>
                  <label for="customer_email">Email address</label>
                </div>
                <div class="field">
                  <input type="password" name="customer[password]" class="full " value="" placeholder="Password" required>
                  <label for="customer_password">Password</label>
                </div>
                <div class="field">
                  <input type="submit" class="button full" value="Sign in">
                </div>
                <input type="hidden" name="customer[remember_me]" value="1">
                <div class="field">
                  <section name="sign-in-with-shop-provider" class="sign-in-with-shop-provider">
                    <p>
                      or
                    </p>
                    <script defer="defer" async="" type="module" src="//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/client.shop-login-button_Dt-1ZKdp.en.esm.js"></script>
                    <script defer="defer" async="" type="module" src="//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/chunk.common_oBwR5RRw.esm.js"></script>
                    <script defer="defer" async="" type="module" src="//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/chunk.modal_B6uJPa9K.esm.js"></script>
                    <script type="module">
                      await import("//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/client.shop-login-button_Dt-1ZKdp.en.esm.js");
                      await import("//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/chunk.common_oBwR5RRw.esm.js");
                      await import("//garagecycles.cc/cdn/shopifycloud/shop-js/modules/v2/chunk.modal_B6uJPa9K.esm.js");
                    </script>
                    <shop-login-button ux-mode="windoid" return-uri="https://garagecycles.cc/pages/game" proxy="true" redirect-type="iframe" response-type="code" data-instance-id="d525978b-5bd5-4d17-b99c-09cb3e2b6b8e" analytics-context="loginWithShopClassicCustomerAccounts" client-id="" flow="classic_customer_accounts" flow-version="sign_in" auto-open="false" consent-challenge="true" disable-sign-up="true" experiments="{}" email=""></shop-login-button>
                  </section>
                </div>
              </form>
              <div class="switch-login-section" id="register-tab" style="gap:10px;">
                <h6>Don’t have an account?</h6> <span class="text-button">Create an account</span>
              </div>
            </div>
            <div class="thb-register-form" id="register-form" style="display: none;">
              <img src="//garagecycles.cc/cdn/shop/files/GC-favicon.png?v=1694299441" class="logoimg" alt="Garage Cycles" width="50" height="50" style="margin-bottom:15px;">
              <form method="post" action="/account?return_url=/pages/game" id="create_customer" accept-charset="UTF-8">
                <input type="hidden" name="form_type" value="create_customer">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="return_to" value="/pages/game" />
                <h4>Create an account</h4>
                <p>Enter your information below to proceed. If you already have an account, please log in instead.</p>					
                <div class="fields">
                  <div class="field">
                    <input type="text" name="customer[first_name]" class="full" value="" placeholder="First name" required>
                    <label for="first_name">First name</label>
                  </div>
                  <div class="field">
                    <input type="text" name="customer[last_name]" class="full" value="" placeholder="Last name" required>
                    <label for="last_name">Last name</label>
                  </div>
                </div>
                <div class="field">
                  <input type="email" name="customer[email]" class="full " value="" placeholder="Email address" required>
                  <label for="email">Email address</label>
                </div>
                <div class="field">
                  <input type="tel" name="customer[note]" class="full " value="" placeholder="Phone" required>
                  <label for="phone">Phone</label>
                </div>
                <div class="field">
                  <input type="password" name="customer[password]" class="full" value="" placeholder="Password" required>
                  <label for="password">Password</label>
                </div>
                <input type="hidden" name="customer[remember_me]" value="1">
                <input type="submit" class="button full" value="Create an account">
              </form>
              <div class="switch-login-section" id="login-tab">
                <h6>Already have an account?</h6> <span class="text-button">Login</span>
              </div>
            </div>
          </div>
        `;

    const loginTab = document.getElementById("login-tab");
    const registerTab = document.getElementById("register-tab");
    const loginForm = document.getElementById("login-form");
    const registerForm = document.getElementById("register-form");

    loginTab.addEventListener("click", () => {
      loginForm.style.display = "block";
      registerForm.style.display = "none";
    });

    registerTab.addEventListener("click", () => {
      loginForm.style.display = "none";
      registerForm.style.display = "block";
    });
  }
}

async function fetchUserHighScore(currentScore = null, previousHighScore = null) {
  if (!window.shopifyCustomer) return 0;

  try {
    let highscore = previousHighScore;

    // 🔹 Fetch highscore from backend if not already passed
    if (highscore == null) {
      const response = await fetch("https://backoffice.brightdigital.co/game/get-highscore.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: window.shopifyCustomer.email,
          customer_id: window.shopifyCustomer.id
        }),
      });
      const data = await response.json();
      if (data.success) highscore = data.highscore;
    }

    // 🔹 Once the leaderboard popup is visible, inject score UI
    if (typeof formContainer !== "undefined" && formContainer.style.display === "block") {
      const discountLine = formContainer.querySelector("p");
      if (discountLine && !formContainer.querySelector(".score-summary")) {
        const high = highscore ?? 0;
        const curr = currentScore ?? player?.score ?? 0;

        const scoreSummary = document.createElement("div");
        scoreSummary.className = "score-summary";
        scoreSummary.style.margin = "20px auto";
        scoreSummary.style.textAlign = "center";
        scoreSummary.style.fontFamily = "Poppins, Arial, sans-serif";
        scoreSummary.style.fontSize = "16px";
        scoreSummary.style.lineHeight = "1.6";
        scoreSummary.style.color = "#222";

        // 🔹 If new high score
        if (curr > high) {
          scoreSummary.innerHTML = `
            <div class="new-score" style="text-align:center; margin:14px 0px">
              <p style="margin:0;">🌟 New High Score 🌟</p>
              <p style="font-size:50px;margin:0;font-weight:bold;line-height:1.4;">${curr}</p>
              <p style="margin:0;">Great Job!</p>
            </div>
          `;
        } else {

          const messages = [
            "Every race counts. Go again!",
            "Your next race could break records.",
            "Nice run! Try again and beat your best.",
            "Keep improving — your high score’s waiting!"
          ];
          const randomMessage = messages[Math.floor(Math.random() * messages.length)];


          // 🔹 If not a new high score
          scoreSummary.innerHTML = `
            <div class="score-box">
              <div style="color: #eb3223;font-weight: 800;font-size: 18px;margin-bottom:4px;">Your Best Score: ${high}</div>
              <div style="font-weight:600; font-size: 16px;margin-bottom:4px;">Current Score: ${curr}</div>
              <div style="color:#000; font-weight:600;margin-top:8px;border-top: 1px solid #e2e2e2;padding: 10px;width: auto;display: inline-block;">${randomMessage}</div>
            </div>
          `;
        }

        discountLine.insertAdjacentElement("afterend", scoreSummary);
      }
    }

    return highscore;
  } catch (err) {
    console.error("Failed to fetch high score:", err);
    return 0;
  }
}



function initGame() {
  resetGameState();
  stageStartTime = Date.now();
  showStageText = true;
  stageTextTime = Date.now();
  startMusic();
  loop();
}

function spawnObjects() {
  const now = Date.now();
  // const spawnInterval = Math.max(1200, 2000 - stage * 50);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  let spawnInterval = Math.max(1200, 2000 - stage * 50);
  spawnInterval *= isMobile ? 1.4 : 1.0;

  if (now - lastSpawnTime < spawnInterval) return;
  lastSpawnTime = now;
  // const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const scale = isMobile ? 1 : 1.25;

  const width = 60 * scale;
  const height = 80 * scale;

  const type = Math.random() < 0.4 ? "boost" : "obstacle";
  const newObject = {
    x: canvas.width + Math.random() * 300,
    y: canvas.height - height,
    type,
    width,
    height,
  };

  if (type === "obstacle") {
    newObject.image = carImages[Math.floor(Math.random() * carImages.length)];
  }

  objects.push(newObject);
}

function drawPlayer() {
  ctx.drawImage(riderImg, player.x, player.y, player.width, player.height);
}

function drawObjects() {
  for (let obj of objects) {
    let img = obj.type === "boost" ? boostImg : obj.image || carImages[0];
    ctx.drawImage(img, obj.x, obj.y, obj.width, obj.height);
  }
}

function drawMuteIcon() {
  const iconSize = 30;
  const x = canvas.width - iconSize - 10;
  const y = 10;

  ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
  ctx.beginPath();
  ctx.arc(x + iconSize / 2, y + iconSize / 2, iconSize / 2, 0, 2 * Math.PI);
  ctx.fill();

  ctx.fillStyle = "#fff";
  ctx.font = `${iconSize * 0.6}px Arial`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  if (isMuted) {
    ctx.fillText("🔇", x + iconSize / 2, y + iconSize / 2);
  } else {
    ctx.fillText("🔊", x + iconSize / 2, y + iconSize / 2);
  }

  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";
}


function drawBackground() {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
}

// // Smooth spin
function spinGlobe() {
  const center = globe.getCenter();
  // globe.setCenter([center.lng + 0.08, center.lat]);
  globe.easeTo({
    center: [center.lng + 0.08, center.lat],
    duration: 100
  });
}
function startSpinning() {
  globeSpinInterval = setInterval(spinGlobe, 120);
}
function stopSpinning() {
  clearInterval(globeSpinInterval);
}

let globe;
function configureMap (){
  mapboxgl.accessToken = "pk.eyJ1IjoiYnJpZ2h0ZGlnaXRhbCIsImEiOiJjbTk4azJ1d2swNHNlMmtyMzNkZTJpYncwIn0.n3-EH19IdVHOh4HxKvhZVg";
  globe = new mapboxgl.Map({
    container: "globe-container",
    style: "mapbox://styles/mapbox/streets-v11",
    center: [-110.35, 39.50],
    zoom: 1.8,
    projection: "globe"
  });
  
  globe.on("load", () => {
    globe.setFog({
      // color: "#ffffff",
      color:"#cfcfcf",
      "high-color": "#add8e6",
      "space-color": "#000000",
      "star-intensity": 0.1
    });
    // startSpinning();
    loadClubRideMarkers();

  });

}
configureMap();

// -------------------------------
// CREATE CLUB RIDE MARKERS ON GLOBE
// -------------------------------
async function loadClubRideMarkers() {
  try {
    const res = await fetch("https://backoffice.brightdigital.co/api/strava-rides-v2.php");
    // const rides = await res.json();
    let rides = [];
    try {
      rides = await res.json();
    } catch(_) {
      console.warn("Empty or invalid JSON from rides endpoint");
      return; // stop silently without breaking map
    }

    if (!Array.isArray(rides) || rides.length === 0) {
      console.warn("No rides data received");
      return;
    }
    if (!Array.isArray(rides)) return;

    rides.forEach((ride) => {
      if (!ride.start_latlng || ride.start_latlng.length < 2) return;

      const lat = ride.start_latlng[0];
      const lng = ride.start_latlng[1];

      // Club image or fallback
      const clubImg =
        ride?.club?.profile && ride.club.profile !== ""
          ? ride.club.profile
          : "https://backoffice.brightdigital.co/assets/plugins/leaflet/images/marker-icon.png";

      // Create marker element
      const el = document.createElement("div");
      el.className = "marker";
      el.style.width = "30px";
      el.style.height = "30px";
      el.style.backgroundImage = `url('${clubImg}')`;
      el.style.backgroundSize = "cover";
      el.style.backgroundPosition = "center";
      el.style.borderRadius = "50%";
      el.style.boxShadow = "0px 0px 5px rgba(0,0,0,0.5)";
      el.style.cursor = "pointer";

      new mapboxgl.Marker(el)
        .setLngLat([lng, lat])
        .addTo(globe);
    });
  } catch (err) {
    console.error("Error loading club ride markers:", err);
  }
}


// function drawBackground() {
//   const canvasAspect = canvas.width / canvas.height;
//   const imageAspect = background.naturalWidth / background.naturalHeight;

//   let drawWidth, drawHeight, drawX, drawY;

//   if (imageAspect > canvasAspect) {
//     drawHeight = canvas.height;
//     drawWidth = canvas.height * imageAspect;
//     drawX = (canvas.width - drawWidth) / 2;
//     drawY = 0;
//   } else {
//     drawWidth = canvas.width;
//     drawHeight = canvas.width / imageAspect;
//     drawX = 0;
//     drawY = (canvas.height - drawHeight) / 2;
//   }

//   ctx.drawImage(background, drawX, drawY, drawWidth, drawHeight);
// }

function toggleMute() {
  isMuted = !isMuted;

  if (isMuted) {
    music.pause();
    music.currentTime = 0;
  } else {
    music.play().catch((err) => console.warn("Music play failed:", err));
  }
}

function startMusic() {
  if (!isMuted) {
    music.play().catch((err) => console.warn("Music play failed:", err));
  }
}

function stopMusic() {
  music.pause();
  music.currentTime = 0;
}

function updateObjects() {
  const baseSpeed  = 5 + stage * 1.5;
    // const speed = 5 + stage * 1.5;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const speedMultiplier = isMobile ? 0.7 : 1.10; 
  const speed = baseSpeed * speedMultiplier;

  for (let i = 0; i < objects.length; i++) {
    const obj = objects[i];
    obj.x -= speed;

    const collided = isColliding(obj, player, 0);

    if (collided) {
      if (obj.type === "boost") {
        bonusSound.currentTime = 0;
        bonusSound.play();
        player.energy += 10;
        player.score += 100;
        objects.splice(i, 1);
        i--;
        continue;
      } else {
        const wasFalling = player.vy > 0;
        const wasAbove = player.y + player.height - player.vy <= obj.y + 5;
        if (wasFalling && wasAbove) {
          bonusSound.currentTime = 0;
          bonusSound.play();
          player.energy += 10;
          player.score += 150;
          player.vy = player.jumpPower / 1.5;
          objects.splice(i, 1);
          i--;
          continue;
        } else {
          player.energy -= 30;
          crashSound.currentTime = 0;
          crashSound.play();
          stopMusic();
          crashed = true;
        }
      }
    }
  }
  objects = objects.filter((obj) => obj.x + obj.width > 0);
}

function updatePlayer() {
  player.vy += gravity;
  player.y += player.vy;

  if (player.y + player.height >= canvas.height) {
    player.y = canvas.height - player.height;
    player.vy = 0;
    player.onGround = true;
  }
}

function update() {
  if (crashed) return;
  if (player.x < 0) player.x = 0;
  if (player.x + player.width > canvas.width) {
    player.x = canvas.width - player.width;
  }

  if (player.y < 0) player.y = 0;
  if (player.y + player.height > canvas.height) {
    player.y = canvas.height - player.height;
  }
  if (keys["ArrowLeft"] && player.energy > 0) {
    player.x -= 5;
    player.energy -= 0.5;
  }
  if (keys["ArrowRight"] && player.energy > 0) {
    player.x += 5;
    player.energy -= 0.5;
  }

  player.score += 1 + stage;
  const kmGain = (1 + stage) / 20;
  stageProgress += kmGain;
  kmLeft = Math.max(0, tourStages[stage - 1].km - stageProgress);
  milesLeft = kmLeft * 0.621371;
  updatePlayer();
  updateObjects();
  spawnObjects();

  if (player.energy <= 0) {
    stopMusic();
    crashed = true;
  }

  if ((kmLeft <= 0 || milesLeft <= 0) && stage < finalStage) {
    stage++;
    player.energy += 50;
    stageProgress = 0;
    showStageText = true;
    stageTextTime = Date.now();
  } else if (stage === finalStage && kmLeft <= 0) {
    clappingSound.currentTime = 0;
    clappingSound.play();
    stopMusic();
    crashed = true;
  }
}

async function render() {
  drawBackground();
  drawPlayer();
  drawObjects();
  drawMuteIcon();

  let current = tourStages[(stage - 1) % tourStages.length];

  ctx.fillStyle = "#fff";
  ctx.font = "400 17px Antonio";
  ctx.fillText(`Nutrition: ${Math.floor(player.energy)} | Score: ${player.score}`, 10, 30);
  ctx.fillText(`Stage ${stage}: ${current.start} → ${current.end}`, 10, 60);
  ctx.fillText(`Remaining: ${kmLeft.toFixed(1)} km (${milesLeft.toFixed(1)} mi)`, 10, 90);

  if (showStageText && Date.now() - stageTextTime < 2000) {
    ctx.fillStyle = "yellow";
    ctx.font = "40px Minecraft";
    ctx.textAlign = "center";
    ctx.fillText(
      `${stage === 1 ? "PROLOGUE" : "STAGE " + stage}`,
      canvas.width / 2,
      canvas.height / 2
    );
    ctx.textAlign = "left";
  }

  if (crashed) {
    //  stopSpinning();
    ctx.fillStyle = "red";
    ctx.font = "32px Minecraft";
    ctx.fillText("Game Over", canvas.width / 2 - 80, canvas.height / 2);
    const customer = window.shopifyCustomer;
    if (customer && !player.scoreSubmitted) {
      // 🧩 STEP 1: Get the user's previous high score BEFORE saving
      const previousHighScore = await fetchUserHighScore();

      const currentStage = tourStages[stage - 1];
      const stageLabel = `Stage ${stage}: ${currentStage.start} → ${currentStage.end} (${currentStage.km} km)`;
      const entry = {
        name: customer.name || maskEmail(customer.email),
        email: customer.email || "",
        phone: customer.phone || "",
        score: player.score,
        stage: stageLabel,
      };

      const results = await fetch("https://backoffice.brightdigital.co/game/save-game.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(entry),
      });

      let positionText = "";
      const response = await results.json();

      if (response.success) {
        const { user, above, below, topScorer } = response;

        positionText += `
              <ul style="list-style: none; padding-left: 0; font-family: Arial, sans-serif; margin-left: 0; margin-bottom: 0;">
            `;

        topScorer.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `<li>-------------------------</li>`;

        above.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `<li><strong style="font-size: 19px;">${user.rank}. ${user.name}: ${user.score}</strong></li>`;

        below.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `</ul>`;
        positionText += `<button onclick="closeLeaderboardPanel()" style="width: min-content;margin-top:10px;padding:8px 16px;cursor:pointer; white-space: nowrap;text-transform: uppercase;display: inline-flex;cursor: pointer;padding: 5px 27px;align-items: center;justify-content: center;height: 52px;font-size: .8125rem;font-weight: 700;letter-spacing: var(--button-letter-spacing, .2em);background: var(--color-accent);color: var(--solid-button-label, #fff);border-radius: var(--button-border-radius, 3px);border: 0;text-align: center;position: relative;appearance: none;transition: color .25s cubic-bezier(.104,.204,.492,1), background-color .25s cubic-bezier(.104,.204,.492,1);">Play Again</button>`;
        formContainer.innerHTML = `<button style="
              width: max-content;
              border-radius: 50%;
              padding: 5px 10px;
              position: fixed;
              left: auto;
              right: 10px;top: 5px;color: red;font-weight: bold;" onclick="closeLeaderboardPanel()">
              x
              </button><h1 style="margin-bottom: 5px; margin-top:20px;">Thanks for racing!</h1>
              <p>Use the discount code <b>GCSPRINT35</b> to get 35% off <u style="color:#EB3223;">
              <a href="https://garagecycles.cc/collections/nutrition-wellness-1">Nutrition</a></u></p>
              ${positionText}`;
            formContainer.style.display = "block";
      } else {
        formContainer.innerHTML = `<h1>Thanks for racing!</h1>`;
        formContainer.style.display = "block";
      }

      updateLeaderboard();
      fetchUserHighScore(player.score || 0, previousHighScore);
      player.scoreSubmitted = true;
    } else if (!customer) {
      const currentScore = player.score;
      await handlePreLoginSubmit();
      await resetGameState(currentScore);
      formContainer.style.display = "block";
      if (!player.pollingLoginStarted) {
        player.pollingLoginStarted = true;
        pollLoginSession(() => {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      }
    }
  }
  if (!gameStarted && showStartMessage) {
    ctx.fillStyle = "white";
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const baseFontSize = isMobile
      ? Math.max(18, canvas.width * 0.06)
      : Math.max(18, canvas.width * 0.03);
    ctx.font = `${baseFontSize}px Arial`;
    ctx.textAlign = "center";
    if(isMobile){
      ctx.font = `${baseFontSize + 4}px  Minecraft`;
      ctx.fillText("TAP TO START AND JUMP", canvas.width / 2, canvas.height / 2 - 25);
      ctx.font = `600 ${baseFontSize - 3}px 'Antonio'`;
      ctx.letterSpacing = 0;
      ctx.fillText("WIN UP TO 35% OFF NUTRITION", canvas.width / 2, canvas.height / 2 );
      // ctx.fillText("and Jump", canvas.width / 2, canvas.height / 2 - 10);
      // ctx.font = `${baseFontSize}px Rubik Wet Paint`;
      // ctx.font = `${baseFontSize}px Arial`;
      // ctx.fontWeight = 700;
      // ctx.fillText("EAT the bars JUMP the cars", canvas.width / 2, canvas.height / 1.85);
      ctx.textAlign= "right";
      ctx.font = `${baseFontSize - 5}px Minecraft`;
      ctx.fillText("EAT THE BARS  + JUMP THE CARS", canvas.width - 8 , canvas.height - 25);
    }
    else{
      ctx.font = `${baseFontSize - 4}px  Minecraft`;
      // ctx.textTransform="uppercase";
      ctx.fillText("PRESS SPACE OR TAP TO START AND JUMP", canvas.width / 2, canvas.height / 2 - 50);
      // ctx.font = `${baseFontSize}px Rubik Wet Paint`;
      ctx.font = `600 ${baseFontSize - 8}px Antonio`;
      // ctx.fontFamily = "Antonio"
      // ctx.fontWeight = "600";
      ctx.letterSpacing = 0;
      ctx.fillText("WIN UP TO 35% OFF NUTRITION", canvas.width / 2, canvas.height / 2 - 5);
      ctx.textAlign= "right";
      ctx.font = `${baseFontSize - 10}px Minecraft`;
      ctx.fillText("EAT THE BARS  + JUMP the CARS", canvas.width - 10 , canvas.height - 20);
      
    }
    ctx.textAlign = "left";
  }
}

async function handlePreLoginSubmit() {
  const currentStage = tourStages[stage - 1];
  const gameState = {
    score: player.score,
    stage,
    stageProgress,
    crashed,
    kmLeft,
    energy: player.energy,
    stageLabel: `Stage ${stage}: ${currentStage.start} → ${currentStage.end} (${currentStage.km} km)`,
  };
  localStorage.setItem("gameState", JSON.stringify(gameState));
}

function closeLeaderboardPanel() {
  showStartMessage = true;
  gameStarted = false;
  crashed = false;
  countdownInProgress = false;
  resetGameState();
  render();
  formContainer.style.display = "none";
}

function closeLoginModal() {
  formContainer.style.display = "none";
  showStartMessage = true;
  gameStarted = false;
  crashed = false;
  countdownInProgress = false;
  render();
}

function loop() {
  if (!player) player = defaultPlayer();
  update();
  render();
  if (!crashed && gameStarted) requestAnimationFrame(loop);
}

function startCountdown() {

  // stopSpinning();
  if (countdownInProgress) return;
  countdownInProgress = true;
  showStartMessage = false;
  render();

  let count = 3;
  countdownEl.style.display = "block";
  countdownEl.textContent = count;
  countdownEl.style.fontFamily = "Minecraft"

  const interval = setInterval(() => {
    count--;
    countdownEl.textContent = count === 0 ? "GO!" : count;

    if (count < 0) {
      clearInterval(interval);
      countdownEl.style.display = "none";
      showStartMessage = false;
      gameStarted = true;
      countdownInProgress = false;
      document.getElementById("leaderboard").style.display = "none";
      initGame();
      // startSpinning();  
    }
  }, 1000);
}

document.addEventListener("keydown", (e) => {
  if ([" ", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
    e.preventDefault();
  }

  keys[e.key] = true;
  if (!gameStarted && e.key === " " && !countdownInProgress) {
    countdownSound.currentTime = 0;
    countdownSound.play().catch((err) => console.warn("Sound blocked:", err));
    startCountdown();
  }
  if (player && (e.key === " " || e.key === "ArrowUp") && player.onGround && player.energy > 0) {
    player.vy = player.jumpPower;
    player.onGround = false;
    player.energy -= 5;
  }
});

document.addEventListener("keyup", (e) => {
  keys[e.key] = false;
});

let touchStartX = null;
let touchStartY = null;
let touchStartTime = null;
let touchHandled = false; // Flag to prevent double handling on mobile

canvas.addEventListener("touchstart", (e) => {
  const touch = e.touches[0];
  touchStartX = touch.clientX;
  touchStartY = touch.clientY;
  touchStartTime = Date.now();
  touchHandled = false; // Reset the flag on new touch
});

canvas.addEventListener("touchend", (e) => {
  const touch = e.changedTouches[0];
  const dx = Math.abs(touch.clientX - touchStartX);
  const dy = Math.abs(touch.clientY - touchStartY);
  const dt = Date.now() - touchStartTime;

  const isTap = dx < 10 && dy < 10 && dt < 300;

  if (isTap) {
    const iconSize = 30;
    const iconX = canvas.width - iconSize - 10;
    const iconY = 10;

    const rect = canvas.getBoundingClientRect();
    const touchX = touch.clientX - rect.left;
    const touchY = touch.clientY - rect.top;

    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    const scaledTouchX = touchX * scaleX;
    const scaledTouchY = touchY * scaleY;

    if (
      scaledTouchX >= iconX &&
      scaledTouchX <= iconX + iconSize &&
      scaledTouchY >= iconY &&
      scaledTouchY <= iconY + iconSize
    ) {
      toggleMute();
      touchHandled = true;
      return;
    }

    if (!gameStarted && !countdownInProgress) {
      countdownSound.currentTime = 0;
      countdownSound.play().catch((err) => console.warn("Sound blocked:", err));
      startCountdown();
      return;
    }

    if (player && player.onGround && player.energy > 0) {
      player.vy = player.jumpPower;
      player.onGround = false;
      player.energy -= 5;
    }
  }

  touchStartX = null;
  touchStartY = null;
  touchStartTime = null;
});

canvas.addEventListener("click", (e) => {
  if (touchHandled) {
    touchHandled = false;
    return;
  }

  const rect = canvas.getBoundingClientRect();
  const clickX = e.clientX - rect.left;
  const clickY = e.clientY - rect.top;

  const iconSize = 30;
  const iconX = canvas.width - iconSize - 10;
  const iconY = 10;

  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;

  const scaledClickX = clickX * scaleX;
  const scaledClickY = clickY * scaleY;

  if (
    scaledClickX >= iconX &&
    scaledClickX <= iconX + iconSize &&
    scaledClickY >= iconY &&
    scaledClickY <= iconY + iconSize
  ) {
    toggleMute();
  }
});

canvas.addEventListener("touchmove", (e) => {
  if (touchStartX !== null) {
    const deltaX = e.touches[0].clientX - touchStartX;
    player.x += deltaX * 0.5;
    touchStartX = e.touches[0].clientX;
  }
});

async function updateLeaderboard() {
  try {
    const res = await fetch("https://backoffice.brightdigital.co/game/get-leaderboard.php");
    const data = await res.json();

    scoresList.innerHTML = "";
    data
      .sort((a, b) => b.score - a.score)
      .slice(0, 5)
      .forEach((entry) => {
        const li = document.createElement("li");
        li.textContent = `${entry.name}: ${entry.score}`;
        scoresList.appendChild(li);
      });
  } catch (err) {
    console.error("Failed to load leaderboard:", err);
  }
}

function attachFormListener() {
  const form = document.getElementById("scoreForm");
  if (!form) return;
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const currentStage = tourStages[stage - 1];
    const stageLabel = `Stage ${stage}: ${currentStage.start} → ${currentStage.end} (${currentStage.km} km)`;
    const entry = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      score: player.score,
      stage: stageLabel,
    };

    leaderboard.push(entry);
    formContainer.innerHTML = "<p>Thanks for racing!</p>";
    setTimeout(() => {
      resetGameState();
      showStartMessage = true;
      gameStarted = false;
      crashed = false;
      countdownInProgress = false;
      render();
    }, 1500);
    fetch("https://backoffice.brightdigital.co/game/save-game.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(entry),
    });
    updateLeaderboard();
    fetchUserHighScore(player.score);
  });
}

const imagesToLoad = [background, riderImg];
let loaded = 0;
// imagesToLoad.forEach((img) => {
//   img.onload = () => {
//     loaded++;
//     if (loaded === imagesToLoad.length) {
//       player = defaultPlayer();
//        document.fonts.load('1em Minecraft').then(() => {
//         player = defaultPlayer();
//         render();
//       });
//       // setTimeout(()=>{
//         // render();
//       // },5000)
      
//     }
//   };
// });
imagesToLoad.forEach((img) => {
  img.onload = () => {
    loaded++;
    if (loaded === imagesToLoad.length) {
      player = defaultPlayer();

      // Load BOTH fonts before rendering
      Promise.all([
        document.fonts.load('1em Minecraft'),
        document.fonts.load('1em Antonio')
      ]).then(() => {
        player = defaultPlayer();
        render();
      });
    }
  };
});


function isColliding(objA, objB, padding = 10) {
  return (
    objA.x + padding < objB.x + objB.width - padding &&
    objA.x + objA.width - padding > objB.x + padding &&
    objA.y + padding < objB.y + objB.height - padding &&
    objA.y + objA.height - padding > objB.y + padding
  );
}

window.addEventListener("DOMContentLoaded", async () => {
  const storedGameState = localStorage.getItem("gameState");

  if (storedGameState && window.shopifyCustomer) {
    const data = JSON.parse(storedGameState);

    const entry = {
      name: window.shopifyCustomer.name || maskEmail(window.shopifyCustomer.email),
      email: window.shopifyCustomer.email || "",
      phone: window.shopifyCustomer.phone || "",
      score: data.score,
      stage: data.stageLabel,
    };

    try {
      const results = await fetch("https://backoffice.brightdigital.co/game/save-game.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(entry),
      });

      const response = await results.json();

      let positionText = "";

      if (response.success) {
        const { user, above, below, topScorer } = response;

        positionText += `
              <ul style="list-style: none; padding-left: 0; font-family: Arial, sans-serif; margin-left: 0; margin-bottom: 0;">
            `;

        topScorer.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `<li>-------------------------</li>`;

        above.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `<li><strong style="font-size: larger;">${user.rank}. ${user.name}: ${user.score}</strong></li>`;

        below.forEach((player) => {
          positionText += `<li style="font-size:14px">${player.rank}. ${player.name}: ${player.score}</li>`;
        });

        positionText += `</ul>`;
        positionText += `<button onclick="closeLeaderboardPanel()" style="width: min-content;margin-top:10px;padding:8px 16px;cursor:pointer; white-space: nowrap;text-transform: uppercase;display: inline-flex;cursor: pointer;padding: 5px 27px;align-items: center;justify-content: center;height: 52px;font-size: .8125rem;font-weight: 700;letter-spacing: var(--button-letter-spacing, .2em);background: var(--color-accent);color: var(--solid-button-label, #fff);border-radius: var(--button-border-radius, 3px);border: 0;text-align: center;position: relative;appearance: none;transition: color .25s cubic-bezier(.104,.204,.492,1), background-color .25s cubic-bezier(.104,.204,.492,1);">Play Again</button>`;
        formContainer.innerHTML = `<button style="
              width: max-content;
              border-radius: 50%;
              padding: 5px 10px;
              position: fixed;
              left: auto;
              right: 10px;top: 5px;color: red;font-weight: bold;" onclick="closeLeaderboardPanel()">
              x
              </button><h1 style="margin-bottom: 5px; margin-top:20px;">Thanks for racing!</h1>
               <div id="scoreSummary" style="margin-top:10px;font-family:Arial,sans-serif;"></div>
              ${positionText}`;
        formContainer.style.display = "block";
      } else {
        formContainer.innerHTML = `<h1>Thanks for racing!</h1>`;
        formContainer.style.display = "block";
      }

      formContainer.style.display = "block";
      updateLeaderboard();
      fetchUserHighScore(data.score);
    } catch (err) {
      console.error("Score restore failed:", err);
    }

    localStorage.removeItem("gameState");
  }
});
